module.exports = __webpack_public_path__ + "img/settings.93db9a8.svg";